<template>
    <MainPage @clickBack="gotoMain()">
        <template v-slot:header>
            {{ lbl.language.title }}
        </template>
        <div class="lang-container">
            <div class="lang-header">{{ lbl.language.select_laguage }}</div>

            <div class="wrap-check">
                <div class="group-check" @click="clickSwitchLang(1054)">
                    <div class="check-language">
                        <img v-if="localeCode == 1054" src="@/assets/icon/ic-checked.svg" alt="">
                        <img v-else src="@/assets/icon/ic-uncheck.svg" alt="">
                    </div>
                    <div class="divider-language"></div>
                    <div class="text-language">
                        <img class="icon" src="@/assets/icon/ic-th.svg" alt="" />
                        {{ lbl.language.thai }}
                    </div>
                </div>
                <div class="group-check" @click="clickSwitchLang(1033)">
                    <div class="check-language">
                        <img v-if="localeCode == 1033" src="@/assets/icon/ic-checked.svg" alt="">
                        <img v-else src="@/assets/icon/ic-uncheck.svg" alt="">
                    </div>
                    <div class="divider-language"></div>
                    <div class="text-language">
                        <img class="icon" src="@/assets/icon/ic-en.svg" alt="" />
                        {{ lbl.language.english }}
                    </div>
                </div>
            </div>

            <!-- <div class="select-lang-wrapper" @click="isShowOption = !isShowOption">
                <div class="select-lang">
                    <img v-if="localeCode == 1054" src="@/assets/icon/ic-th.png" alt="">
                    <img v-else src="@/assets/icon/ic-en.png" alt="">

                    <div class="icon-divider"></div>

                    <div class="lang-text">
                        {{ localeCode == 1054 ? 'Thai' : 'English'}}
                    </div>

                </div>
                <img v-if="!isShowOption" src="@/assets/icon/ic-arrw-down.svg" alt="">
                <img v-else src="@/assets/icon/ic-arrw-up.svg" alt="">
            </div>
            <div class="option-container" v-if="isShowOption">
                <div class="option-wrapper" @click="clickSwitchLang()">
                    <div>
                        <img v-if="localeCode == 1033" src="@/assets/icon/ic-th.png" alt="">
                        <img v-else src="@/assets/icon/ic-en.png" alt="">
                    </div>
                    <div class="option-text">
                        {{ localeCode == 1033 ? 'Thai' : 'English'}}
                    </div>
                </div>
            </div> -->
            <!-- <div class="bt-save">
                <OrangeButton @onClick="onClickSave(localeCode)">Save</OrangeButton>
            </div> -->
        </div>
    </MainPage>
</template>

<script>
import MainPage from '@/components/Layout/Page/MainPage.vue';
// mixin
import LocaleMixin from '@/mixin/LocaleMixin';
// helper
import Locale from '@/helper/locale/Locale';
// import OrangeButton from '@/components/Button/OrangeButton.vue';
import ConfigManager from '@/config/ConfigManager.js';
import Account from "@/helper/AccountHelper.js"
import BlobService from "@/service/BlobService.js";

export default {
    name: "LanguagePage",
    mixins: [LocaleMixin],
    components: {
        MainPage,
        // OrangeButton
    },
    data: function() {
        return {
            localeCode: Locale.getLocaleCode(),

        };
    },
    created: function() {
        console.log(this.localeCode)
    },
    methods: {
        gotoMain: function() {
            this.$router.back()
        },
        clickSwitchLang: async function(param) {
            this.localeCode = param;
            let searchlist = await this.initialSearchListConfig();
            if (searchlist) {
                this.switchLang(this.localeCode);
            }
        },
        // onClickSave: function (localeCode) {
        //     var locale = localeCode
        //     this.switchLang(locale);
        // }
        initialSearchListConfig: async function () {
            this.query = Account.getCacheQuery();
            let app_id = this.query.appId;
            this.blobURL  = `${ConfigManager.getBlobUrl()}/config/b2b_marketplace/${app_id}`;
            let time = new Date().getTime()
            var searchfile = `searchlist/${this.localeCode}.json?t=${time}`;
            return new Promise((resolve, reject) => {
                BlobService.apiGetConfig(`${this.blobURL}`, searchfile)
                .then(res => {
                    console.log(res.data);
                    this.searchlist = res.data;
                    Account.setCacheCustom('searchlist',this.searchlist)
                    resolve(true);
                })
                .catch(ex => {
                    console.log(ex)
                    reject(false);
                });
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "../style/LanguagePage.scss";
</style>
